import { useTranslation } from 'react-i18next';
import { BarChart3 } from 'lucide-react';
import { PrefSection, type PrefVariant } from '@/components/PrefSection';
import { useShowSummaryStats } from '@/hooks/useShowSummaryStats';
import { cn } from '@/lib/utils';

/**
 * Toggle for the patient Summary's KPI cards (Meals in range, Active goals,
 * Calories/day, Time in Range, Logging streak). Off by default; saved
 * per-device like the theme / font / thumbnail prefs.
 */
export const SummaryStatsToggle = ({ variant = 'card' }: { variant?: PrefVariant }) => {
  const { t } = useTranslation();
  const [show, setShow] = useShowSummaryStats();

  const toggle = (
    <button
      type="button"
      role="switch"
      aria-checked={show}
      aria-label={t('Show Summary Statistics')}
      onClick={() => setShow(!show)}
      className={cn(
        'relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors',
        show ? 'bg-primary' : 'bg-muted-foreground/30',
      )}
    >
      <span
        className={cn(
          'inline-block h-5 w-5 transform rounded-full bg-white shadow transition-transform',
          show ? 'translate-x-[1.375rem]' : 'translate-x-0.5',
        )}
      />
    </button>
  );

  return (
    <PrefSection
      variant={variant}
      icon={BarChart3}
      title={t('Show Summary Statistics')}
      description={t(
        'Show the KPI cards on the patient Summary (meals in range, active goals, calories/day, time in range, logging streak). Saved to this browser.',
      )}
      action={toggle}
    />
  );
};
